// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_ji-1";
export var rowFirst = "_ji-3";
export var rowLast = "_ji-5";
export var rowMiddle = "_ji-4";
export var ticketListScroll = "_ji-2";
export var ticketStack = "_ji-0";